export const ANCIL_TERMS = {
  inclusion: {
    code: 'baggageAndSeat',
    name: 'Includes 7kg carry-on baggage, 20kg checked baggage and standard seat selection',
    subtitle:
      'You can select your seats through ‘Manage Booking’ after receiving your booking confirmation',
  },
  title: 'Baggage and Seats',
} as const;
